/**
 * @description used to transform result from ORDERS CREATE Api of api-gateway
 * @api - /checkout/order/create/v2 .
 *
 */
import { payUPaymentRequestDTOTransformer } from './payUPaymentRequestDTOTransformer';
import { orderDataTransformer } from './orderDataTransformer';
import { upiPaymentRequestDTOTransformer } from './upiPaymentRequestDTOTransformer';
import { razorpayRequestDTOTransformer } from './razorpayRequestDTOTransformer';
import { cashFreeRequestDTOTransformer } from './cashFreeRequestDTOTransformer';
import { cashFreeSeamlessDTOTransformer } from './cashFreeSeamlessDTOTransformer';
import { itemTransformer } from './itemTransformer';


interface ResponseType {
  items:object,
  cod_delay_message:string,
  is_new_user:boolean,
  paymentStatus:string,
  status: string,
  paymentGateway:string,
  orderState:string,
  paytmRequestDTO:object,
  payUPaymentRequestDTO:object,
  paymentExtraParamsDTO: object,
  razorPayPaymentRequestDTO:object,
  refer_a_friend:string,
  shipping_address:object,
  upiPaymentRequestDTO:object,
  cashfreePaymentRequestDTO:object,
  cashfreeSeamlessPaymentRequestDTO:object,
  hashValue:string,
  bankcode:string,
  paymentInitiationRequestDTO?:object;
}

interface IGiftCardPurchaseRequest{
  id: string,
  amount: string,
  status: string,
  paymentId: string,
  paymentMode: string,
  urlToken: string,
  source: string,
  domain: string,
  senderEmail: string,
  senderMobile: string,
  senderName: string
}
export interface IgiftcardPurchaseResponse extends IGiftCardPurchaseRequest{
    success: boolean,
    id: string,
    amount: string,
    customerId: string,
    deviceType: string,
    appVersion: string,
    cardProgramGroupName: string,
    recipientName: string,
    senderName: string, 
    recipientMobile: string,
    senderMobile: string,
    recipientEmail: string,
    senderEmail: string,
    orderStatus: string,
    message: string,
    giftcardNumber: string,
    type: string,
    cardTypeName: string,
    urlToken: string,
    tinyUrl: string,
    purchaseRequest: IGiftCardPurchaseRequest,
    source: string,
    domain: string,
    additionalInfo: string,
    paymentMode: string,
    remarks: string,
    outstandingBalance: string
}

const getGiftCardPurchaseResponseStatus = (response: any) => {
  // For checking purchase response of multi gift card purchase
  if(Array.isArray(response)) {
    return response.length > 0 ? response[0].status : ''
  }
  return ''
}

export const giftCardPurchaseTransformer = (response: ResponseType) => {
  let transformedItems = itemTransformer(response.items || []);
  
  return {
    codDelayMessage: response.cod_delay_message || '',
    isNewUser: response.is_new_user || -1,
    items: transformedItems,
    orderData: orderDataTransformer(response || {}),
    paymentStatus: response.paymentStatus || response.status || '',
    paymentGateway: response.paymentGateway || '',
    orderStatus: response.status || getGiftCardPurchaseResponseStatus(response) || '',
    paytmRequestDTO: response.paytmRequestDTO || {},
    payUPaymentRequestDTO: payUPaymentRequestDTOTransformer(
        response.payUPaymentRequestDTO || {},
      ),
    paymentExtraParamsDTO: response.paymentExtraParamsDTO || {},
    razorPayPaymentRequestDTO: razorpayRequestDTOTransformer(response.razorPayPaymentRequestDTO || {}),
    referAFriend: response.refer_a_friend || {},
    shippingAddress: response.shipping_address || {},
    upiPaymentRequestDTO: upiPaymentRequestDTOTransformer(response.upiPaymentRequestDTO || {}),
    cashfreePaymentRequestDTO: cashFreeRequestDTOTransformer(response.cashfreePaymentRequestDTO || {}),
    cashfreeSeamlessPaymentRequestDTO: cashFreeSeamlessDTOTransformer(response.cashfreeSeamlessPaymentRequestDTO || {}),
    hashValue: response.hashValue || '', // added for PaymentSuccess incase of guest users
    paymentInitiationRequestDTO: response?.paymentInitiationRequestDTO
  };
};

export const giftcardPurchaseResponseTransformer = (response: [IgiftcardPurchaseResponse]) =>{

  let purchaseRequest = {} as IGiftCardPurchaseRequest;

  if(response.length > 0){
    purchaseRequest = {
      ...response[0]?.purchaseRequest,
      senderEmail: response[0]?.senderEmail,
      senderMobile:  response[0]?.senderMobile,
      senderName: response[0]?.senderName,
    };
  }

  return { 
    id: purchaseRequest?.id || "",
    amount: purchaseRequest?.amount || "",
    orderStatus: purchaseRequest?.status || "",
    paymentId: purchaseRequest?.paymentId || "",
    paymentMode: purchaseRequest?.paymentMode || "",
    urlToken: purchaseRequest?.urlToken || "",
    source: purchaseRequest?.source || "",
    domain: purchaseRequest?.domain || "",
    senderEmail: purchaseRequest?.senderEmail || "",
    senderMobile: purchaseRequest?.senderMobile || "",
    senderName: purchaseRequest?.senderName || "",
    success: true,
    data: [
      ...response
    ]
  };
}